import { Link } from 'react-router-dom';
import Footer from '../home/components/Footer';

export default function MentionsLegalesPage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white border-b border-rose-100 sticky top-0 z-50">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="text-2xl font-light text-gray-900">
              Peau<span className="font-semibold text-rose-500">Perlée</span>
            </Link>
            <Link 
              to="/" 
              className="text-sm text-gray-600 hover:text-rose-500 transition-colors cursor-pointer flex items-center gap-2"
            >
              <i className="ri-arrow-left-line"></i>
              Retour à l'accueil
            </Link>
          </div>
        </div>
      </nav>

      {/* Content */}
      <div className="container mx-auto px-6 lg:px-12 py-16">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-light text-gray-900 mb-8">
            Mentions Légales & <span className="font-semibold text-rose-500">Politiques</span>
          </h1>

          {/* Mentions Légales */}
          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-6 flex items-center gap-3">
              <i className="ri-file-text-line text-rose-500"></i>
              Mentions Légales
            </h2>
            
            <div className="space-y-6 text-gray-700 leading-relaxed">
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Éditeur du site</h3>
                <p><strong>Nom de l'entreprise :</strong> PeauPerlée</p>
                <p><strong>Forme juridique :</strong> Entreprise individuelle</p>
                <p><strong>Adresse :</strong> Mons, Belgique</p>
                <p><strong>Téléphone :</strong> +32 472 52 11 10</p>
                <p><strong>Email :</strong> info@peauperlee.com</p>
                <p><strong>Numéro d'entreprise :</strong> 0667792738</p>
                <p><strong>TVA :</strong> BE0667792738</p>
              </div>

              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Directeur de la publication</h3>
                <p>Lechien Lidwine</p>
              </div>

              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Hébergement</h3>
                <p><strong>Hébergeur :</strong> Readdy.ai</p>
                <p><strong>Site web :</strong> <a href="https://readdy.ai" target="_blank" rel="noopener noreferrer" className="text-rose-500 hover:underline cursor-pointer">https://readdy.ai</a></p>
              </div>

              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Plateforme e-commerce</h3>
                <p><strong>Boutique en ligne :</strong> Shopify</p>
                <p><strong>Site web :</strong> <a href="https://www.shopify.com" target="_blank" rel="noopener noreferrer" className="text-rose-500 hover:underline cursor-pointer">https://www.shopify.com</a></p>
              </div>
            </div>
          </section>

          {/* Politique de Confidentialité */}
          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-6 flex items-center gap-3">
              <i className="ri-shield-check-line text-rose-500"></i>
              Politique de Confidentialité
            </h2>
            
            <div className="space-y-6 text-gray-700 leading-relaxed">
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Collecte des données personnelles</h3>
                <p>Nous collectons les données personnelles suivantes :</p>
                <ul className="list-disc list-inside ml-4 mt-2 space-y-1">
                  <li>Nom et prénom</li>
                  <li>Adresse email</li>
                  <li>Numéro de téléphone</li>
                  <li>Adresse de livraison</li>
                  <li>Informations de paiement (traitées de manière sécurisée)</li>
                </ul>
              </div>

              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Utilisation des données</h3>
                <p>Vos données personnelles sont utilisées pour :</p>
                <ul className="list-disc list-inside ml-4 mt-2 space-y-1">
                  <li>Traiter vos commandes et livraisons</li>
                  <li>Vous contacter concernant vos achats</li>
                  <li>Améliorer nos services</li>
                  <li>Vous envoyer des offres promotionnelles (avec votre consentement)</li>
                  <li>Respecter nos obligations légales</li>
                </ul>
              </div>

              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Protection des données</h3>
                <p>Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles appropriées pour protéger vos données personnelles contre tout accès non autorisé, modification, divulgation ou destruction.</p>
              </div>

              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Vos droits</h3>
                <p>Conformément au RGPD, vous disposez des droits suivants :</p>
                <ul className="list-disc list-inside ml-4 mt-2 space-y-1">
                  <li>Droit d'accès à vos données personnelles</li>
                  <li>Droit de rectification de vos données</li>
                  <li>Droit à l'effacement de vos données</li>
                  <li>Droit à la limitation du traitement</li>
                  <li>Droit à la portabilité de vos données</li>
                  <li>Droit d'opposition au traitement</li>
                </ul>
                <p className="mt-2">Pour exercer ces droits, contactez-nous à : <a href="mailto:info@peauperlee.com" className="text-rose-500 hover:underline cursor-pointer">info@peauperlee.com</a></p>
              </div>

              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Conservation des données</h3>
                <p>Vos données personnelles sont conservées pendant la durée nécessaire aux finalités pour lesquelles elles ont été collectées, conformément à la législation en vigueur.</p>
              </div>
            </div>
          </section>

          {/* Cookies */}
          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-6 flex items-center gap-3">
              <i className="ri-cookie-line text-rose-500"></i>
              Politique des Cookies
            </h2>
            
            <div className="space-y-6 text-gray-700 leading-relaxed">
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Qu'est-ce qu'un cookie ?</h3>
                <p>Un cookie est un petit fichier texte déposé sur votre ordinateur lors de la visite d'un site web. Il permet de mémoriser des informations relatives à votre navigation.</p>
              </div>

              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Types de cookies utilisés</h3>
                <ul className="list-disc list-inside ml-4 space-y-1">
                  <li><strong>Cookies essentiels :</strong> Nécessaires au fonctionnement du site</li>
                  <li><strong>Cookies de performance :</strong> Pour analyser l'utilisation du site</li>
                  <li><strong>Cookies fonctionnels :</strong> Pour mémoriser vos préférences</li>
                </ul>
              </div>

              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Gestion des cookies</h3>
                <p>Vous pouvez à tout moment désactiver les cookies dans les paramètres de votre navigateur. Cependant, cela peut affecter certaines fonctionnalités du site.</p>
              </div>
            </div>
          </section>

          {/* CGV */}
          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-6 flex items-center gap-3">
              <i className="ri-shopping-bag-line text-rose-500"></i>
              Conditions Générales de Vente
            </h2>
            
            <div className="space-y-6 text-gray-700 leading-relaxed">
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Commandes</h3>
                <p>Toute commande passée sur notre site constitue un contrat de vente. En validant votre commande, vous acceptez nos conditions générales de vente.</p>
              </div>

              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Prix</h3>
                <p>Les prix sont indiqués en euros (€) et incluent la TVA applicable. Nous nous réservons le droit de modifier nos prix à tout moment, mais les produits seront facturés sur la base des tarifs en vigueur au moment de la validation de la commande.</p>
              </div>

              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Paiement</h3>
                <p>Le paiement s'effectue de manière sécurisée via notre plateforme de paiement. Nous acceptons les cartes bancaires et autres moyens de paiement indiqués lors du processus de commande.</p>
              </div>

              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Livraison</h3>
                <p>Livraison offerte dès 49,99€ d'achat. Votre colis est préparé avec soin dans les 24 à 48h ouvrées suivant votre commande. La livraison est ensuite prévue entre 5 et 8 jours ouvrés. Nous nous efforçons de respecter ces délais, mais ne pouvons être tenus responsables des retards dus à des circonstances indépendantes de notre volonté.</p>
              </div>

              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Droit de rétractation</h3>
                <p>Conformément à la législation européenne, vous disposez d'un délai de 14 jours à compter de la réception de votre commande pour exercer votre droit de rétractation, sans avoir à justifier de motifs ni à payer de pénalités.</p>
                <p className="mt-2">Les produits doivent être retournés dans leur emballage d'origine, non ouverts et non utilisés.</p>
              </div>

              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Garanties</h3>
                <p>Tous nos produits bénéficient de la garantie légale de conformité et de la garantie contre les vices cachés, conformément à la législation en vigueur.</p>
              </div>
            </div>
          </section>

          {/* Propriété Intellectuelle */}
          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-6 flex items-center gap-3">
              <i className="ri-copyright-line text-rose-500"></i>
              Propriété Intellectuelle
            </h2>
            
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>L'ensemble du contenu de ce site (textes, images, vidéos, logos, etc.) est protégé par le droit d'auteur et appartient à PeauPerlée ou à ses partenaires.</p>
              <p>Toute reproduction, distribution, modification ou utilisation du contenu sans autorisation préalable est strictement interdite.</p>
            </div>
          </section>

          {/* Contact */}
          <section className="bg-gradient-to-br from-rose-50 to-blush-50 rounded-lg p-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4 flex items-center gap-3">
              <i className="ri-mail-line text-rose-500"></i>
              Nous Contacter
            </h2>
            <p className="text-gray-700 mb-4">Pour toute question concernant nos mentions légales ou nos politiques :</p>
            <div className="space-y-2 text-gray-700">
              <p className="flex items-center gap-2">
                <i className="ri-phone-line text-rose-500"></i>
                <strong>Téléphone :</strong> +32 472 52 11 10
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-mail-line text-rose-500"></i>
                <strong>Email :</strong> <a href="mailto:info@peauperlee.com" className="text-rose-500 hover:underline cursor-pointer">info@peauperlee.com</a>
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-map-pin-line text-rose-500"></i>
                <strong>Adresse :</strong> Mons, Belgique
              </p>
            </div>
          </section>

          <div className="mt-8 text-sm text-gray-500 text-center">
            Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
